import React from 'react'
import styled from 'styled-components'
import Color from 'constants/colors'

const Rating = styled.span`
	text-align:left;
	width: 48%;
`;

const Label = styled.h3`
	display: inline-block;
	font-weight: normal;
	margin: 0;
	text-align: right;
	width: 50%
`;

const BlockTitle = styled.h3`
	color: #333;
	text-align: center;
	margin-bottom: 10px;

`;


const mapLabelToEmoji = (label) => {
	switch(label){
		case "complexity":
			return "⚙";
		case "funding":
			return "🤑";
		case "impact":
			return "🥊";
		case "controversy":
			return "🍆";
		case "taxpayer cost":
			return "💰";
		default:
			return "⭐";
	}
}

const Container = styled.div`
	background: ${props=>props.isHighlighted ? (props.isHovered && !props.stayVisible ? Color('purple') : "black"): "white"};
	color: ${props=>props.isHighlighted ? "white": "black"};
	cursor: pointer;
`;

const Position = styled.div`
	position: absolute;
	z-index: 2;
	font-family: ${props=>props.theme.fonts.h2};
	font-size: 14px;
`;
const InfoBox = styled.div`
	position: relative;
	background-color: white;
	padding: 20px 10px;
	max-width: 300px;
	top: -15px;
	right: -250px;
	border: 3px solid black;
	border-radius: 4px;
	box-shadow: 0 0 4px rgba(0,0,0,0.1);
	cursor: pointer;
  @media screen and (max-width: 767px) {
  	top: 10px;
  	left: 0;
  }
`;

const BlockContainer = styled.div`
	position: relative;
	top: ${props=>props.showAnnos? 0 : '320px' };
	transition: top 250ms cubic-bezier(0.165, 0.84, 0.44, 1);
	padding: 10px 0;
	border-radius: 3px;
  @media screen and (max-width: 1023px) {
  	top: 0;
  }
  @media print {
    display: none;
`;

class RatingLine extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			isHovered: false,
			stayVisible: false,
		}
	}
	handleMouseEnter = () => {
		this.setState({isHovered: true})
	}

	handleMouseLeave = () => {
		// hide explanation
		this.setState({isHovered: false})
	}

	toggleVisibility = (e) => {
		e.preventDefault();
		this.setState({stayVisible: !this.state.stayVisible});
	}

	render() {
		const {children, explanation} = this.props;
		const {stayVisible, isHovered} = this.state;
		const showInfo = stayVisible ? true : isHovered;
		return(
			<React.Fragment>
				<Container
					isHighlighted={showInfo}
					isHovered={isHovered}
					stayVisible={stayVisible}
					onMouseEnter={this.handleMouseEnter}
					onMouseLeave={this.handleMouseLeave}
					onClick={this.toggleVisibility}
				>
					{children}
				</Container>
				{showInfo && 
					<Position>
						<InfoBox>
							{explanation}
						</InfoBox>
					</Position>
				}
			</React.Fragment>
		);
	}
}

const RatingsBlock = (props) => {
	if(!props.data) return null;
	const ratingBlock = props.data.map( (line, i) => {
		const {label, rating, explanation} = line;
		const emojis = mapLabelToEmoji(label).repeat(rating);
		return(
			<RatingLine explanation={explanation} key={i}>
				<Label>{label}</Label>
				:&nbsp;
				<Rating>{emojis}</Rating>
			</RatingLine>
		);
	});

	return(
  	<BlockContainer showAnnos={props.showAnnos}>
    	<BlockTitle>By The Bay's analysis</BlockTitle>
			{ratingBlock}
  	</BlockContainer>
	);
}




export default RatingsBlock;


// WEBPACK FOOTER //
// ./src/pages/june-5/props/components/RatingsBlock.js